<template>
  <div>
    <div :class="$style.envelope" v-if="role.role_id">
      <transition name="fade">
        <component
          :is="currentPage"
          @setPage="setPage"
          @backWallet="backWallet"
          @setWalletType="setWalletType"
          @setWalletMethod="setWalletMethod"
          ref="customComponent"
          ></component>
      </transition>
    </div>
    <img v-else :class="$style.hint" :src="`${$cdnLink}/red-envelope/v2/empty.png`"/>
  </div>
</template>

<script>
import Receive from "./Receive";
import Condition from "./Condition";
import Wallet from "./Wallet.vue";
import Record from "./Record.vue";
import Step from "./Step.vue";
import Rule from "./Rule.vue";
import { mapState } from "vuex";
import ReceiveV2 from "./ReceiveV2.vue";
import WalletV2 from './WalletV2.vue'
import ConditionV2 from './ConditionV2.vue'

export default {
  name: "",
  data() {
    return {
      currentPage: '',
      walletType: 1,
      walletMethod: 0,
    };
  },
  components: {
    Receive,
    Condition,
    Wallet,
    Record,
    Step,
    WalletV2,
    ReceiveV2,
    ConditionV2
  },
  mounted() {
    this.currentPage = this.receive_info.version == 1 ? Receive : ReceiveV2;
  },
  computed: {
    ...mapState({
      role: (state) => state.redEnvelope.role,
      receive_info: (state) => state.redEnvelope.receive_info
    }),
  },
  methods: {
    setPage(type) {
      switch (type) {
        case "condition":
          this.currentPage = this.receive_info.version == 1 ? Condition : ConditionV2;
          break;
        case "wallet":
          this.currentPage = this.receive_info.version == 1 ? Wallet : WalletV2;
          break;
        case "record":
          this.currentPage = Record;
          break;
        case "step":
          this.currentPage = Step;
          break;
        case "rule":
          this.currentPage = Rule;
          break;
        default:
          this.currentPage = this.receive_info.version == 1 ? Receive : ReceiveV2;
      }
    },
    setWalletType(type) {
      this.walletType = type;
    },
    setWalletMethod(method) {
      this.walletMethod = method;
    },
    // 从提现领取步骤页返回钱包页，直接展示钱包界面
    backWallet() {
      this.currentPage = this.receive_info.version == 1 ? Wallet : WalletV2;
      setTimeout(() => {
        this.$refs.customComponent.setWithDrawStep(this.walletType, this.walletMethod);
      })
    }
  },
};
</script>
<style lang="scss">
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
<style lang="scss" module>
.envelope {
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0);
}
.hint {
  display: block;
  width: 140px;
  margin: auto;
  padding-top: 60px;
}
</style>